/* tslint:disable */
/* eslint-disable */
/**
 * Marco Email Parser API
 * Marco Email Parser API
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { BetterRoom } from './BetterRoom';
import {
    BetterRoomFromJSON,
    BetterRoomFromJSONTyped,
    BetterRoomToJSON,
    BetterRoomToJSONTyped,
} from './BetterRoom';
import type { RankedBetterRoom } from './RankedBetterRoom';
import {
    RankedBetterRoomFromJSON,
    RankedBetterRoomFromJSONTyped,
    RankedBetterRoomToJSON,
    RankedBetterRoomToJSONTyped,
} from './RankedBetterRoom';

/**
 * Response payload for GET /user/hotel_stays/{stay_id}/better_rooms.
 * `top_rooms` is the LLM-ranked top 3; `all_rooms` is the full deduped list
 * of higher-tier rooms returned by the supplier.
 * 
 * @export
 * @interface BetterRoomsResponse
 */
export interface BetterRoomsResponse {
    /**
     * 
     * @type {boolean}
     * @memberof BetterRoomsResponse
     */
    betterRoomsAvailable: boolean;
    /**
     * 
     * @type {Array<RankedBetterRoom>}
     * @memberof BetterRoomsResponse
     */
    topRooms: Array<RankedBetterRoom>;
    /**
     * 
     * @type {Array<BetterRoom>}
     * @memberof BetterRoomsResponse
     */
    allRooms: Array<BetterRoom>;
    /**
     * When the LLM ranking was computed. Null if ranking has not yet run.
     * @type {Date}
     * @memberof BetterRoomsResponse
     */
    rankedAt?: Date | null;
}

/**
 * Check if a given object implements the BetterRoomsResponse interface.
 */
export function instanceOfBetterRoomsResponse(value: object): value is BetterRoomsResponse {
    if (!('betterRoomsAvailable' in value) || value['betterRoomsAvailable'] === undefined) return false;
    if (!('topRooms' in value) || value['topRooms'] === undefined) return false;
    if (!('allRooms' in value) || value['allRooms'] === undefined) return false;
    return true;
}

export function BetterRoomsResponseFromJSON(json: any): BetterRoomsResponse {
    return BetterRoomsResponseFromJSONTyped(json, false);
}

export function BetterRoomsResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): BetterRoomsResponse {
    if (json == null) {
        return json;
    }
    return {
        
        'betterRoomsAvailable': json['better_rooms_available'],
        'topRooms': ((json['top_rooms'] as Array<any>).map(RankedBetterRoomFromJSON)),
        'allRooms': ((json['all_rooms'] as Array<any>).map(BetterRoomFromJSON)),
        'rankedAt': json['ranked_at'] == null ? undefined : (new Date(json['ranked_at'])),
    };
}

export function BetterRoomsResponseToJSON(json: any): BetterRoomsResponse {
    return BetterRoomsResponseToJSONTyped(json, false);
}

export function BetterRoomsResponseToJSONTyped(value?: BetterRoomsResponse | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'better_rooms_available': value['betterRoomsAvailable'],
        'top_rooms': ((value['topRooms'] as Array<any>).map(RankedBetterRoomToJSON)),
        'all_rooms': ((value['allRooms'] as Array<any>).map(BetterRoomToJSON)),
        'ranked_at': value['rankedAt'] == null ? value['rankedAt'] : value['rankedAt'].toISOString(),
    };
}

